module.exports = __webpack_public_path__ + "static/media/icnProxPasos48horas.f7a1d525.svg";